import {
  EditAttributeData,
  EditLevelAttributeData,
  EditTreatmentOverviewFormData,
} from '~/lib/types/notes/EditTreatmentOverviewFormData';
import { Tag, Text } from '@equip.health/ui';
import { TreatmentLevelIdToTagColorMap } from '~/components/common/TreatmentOverviewCard/TreatmentLevelIdToTagColorMap';

export const EditTreatmentOverviewFormExplanationStepAttributeLabel = ({
  value,
  isOld,
  attribute,
}: {
  value?: EditAttributeData | EditLevelAttributeData;
  isOld?: boolean;
  attribute: keyof EditTreatmentOverviewFormData;
}) => {
  if (!value) {
    return <Text color={isOld ? 'neutral.tertiary' : undefined}>Not set</Text>;
  }

  if (attribute === 'level') {
    const val = value as EditLevelAttributeData;
    return (
      <Tag
        color={TreatmentLevelIdToTagColorMap[val.id]}
        id={`edit_treatment_overview_form_explanation_step_attr_row_tag_${val.label}`}
        value={value.label}
      />
    );
  }

  return (
    <Text color={isOld ? 'neutral.tertiary' : undefined}>{value.label}</Text>
  );
};
